import React, { Component } from 'react';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">          
          <p>
            Tano home
          </p>          
        </header>
      </div>
    );
  }
}

export default App;
